import React from 'react'

export default function LeftOverDetails() {
  return (
    <div>LeftOverDetails</div>
  )
}
